import React, { lazy } from "react";
import { useSelector } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";
import { currenEnv } from "./config/endPointsConfig";
import {
  APP_ROUTES,
  BUNDLE_TYPES,
  ENVIRONMENTS,
  SUBSCRIPTION_TYPES,
} from "./constants/appConstants";
import routes from "./routes";
const ProtectedRoute = lazy(() => import("./pages/login/ProtectedRoute"));

const AppRoutes = () => {
  const { user } = useSelector((state) => state.auth);

  const isRestricted = (key) => {
    switch (key) {
      case BUNDLE_TYPES.JUST4U:
        return false;
      case BUNDLE_TYPES.BROADBAND:
        return true;
      case BUNDLE_TYPES.MASHUP:
        return (
          user?.primary_number?.subscription_type?.name ===
          SUBSCRIPTION_TYPES.POSTPAID
        );
      default:
        return false;
    }
  };

  return (
    <Switch>
      {routes.map((route) => {
        return route.protected ? (
          <ProtectedRoute
            path={route.path}
            exact={route.exact}
            key={route.name}
          >
            {currenEnv === ENVIRONMENTS.PROD &&
            isRestricted(route.name.toLowerCase()) ? (
              <Redirect to={APP_ROUTES.SHOP_LANDING} />
            ) : (
              <route.component />
            )}
          </ProtectedRoute>
        ) : (
          <Route path={route.path} exact={route.exact} key={route.name}>
            <route.component />
          </Route>
        );
      })}
    </Switch>
  );
};

export default AppRoutes;
